import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { useI18n } from "@/i18n";

export default function PromptBlock({ label, text }) {
  const { t } = useI18n();
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {}
  };
  return (
    <div className="relative bg-[#0A0A0A] border-l-2 border-gold my-6 p-6 pr-14" data-testid="prompt-block">
      {label && <div className="text-[10px] tracking-[0.25em] uppercase text-gold-muted mb-3">{label}</div>}
      <p className="font-mono text-sm text-ink-soft leading-relaxed whitespace-pre-wrap">{text}</p>
      <button
        onClick={copy}
        data-testid="prompt-copy-button"
        title={t("lesson.copy")}
        className="absolute top-4 right-4 text-ink-soft hover:text-gold transition-colors flex items-center gap-1 text-xs"
      >
        {copied ? <Check size={16} strokeWidth={1.5} /> : <Copy size={16} strokeWidth={1.5} />}
        <span className="hidden sm:inline">{copied ? t("lesson.copied") : t("lesson.copy")}</span>
      </button>
    </div>
  );
}
